<template>
  <nav class="breadcrumb">
    <ol class="breadcrumb__list">
      <li v-for="(item, index) in items" :key="index" class="breadcrumb__item">
        <component
          :is="item.url ? 'router-link' : 'span'"
          :to="item.url"
          class="breadcrumb__link"
          :class="{ 'breadcrumb__link--active': !item.url }"
        >
          <BaseIcon v-if="item.icon" :name="item.icon" class="breadcrumb__icon" />
          {{ item.label }}
        </component>
        <BaseIcon v-if="index < items.length - 1" name="chevron" class="breadcrumb__separator" />
      </li>
    </ol>
  </nav>
</template>

<script>
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default {
    name: 'Breadcrumb',

    components: {
      BaseIcon,
    },

    props: {
      items: {
        type: Array,
        required: true,
        validator: (items) => {
          return items.every((item) => typeof item === 'object' && typeof item.label === 'string');
        },
      },
    },
  };
</script>

<style scoped lang="scss">
  .breadcrumb {
    &__list {
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0;
      padding: 0;
      gap: 0.125rem;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 0.125rem;
    }

    &__link {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      padding: 0.25rem 0.5rem;
      border-radius: 0.375rem;
      font-size: 0.875rem;
      font-weight: 500;
      text-decoration: none;
      color: var(--slate-600);
      transition: all 0.2s ease;

      &:hover:not(&--active) {
        background-color: var(--slate-100);
        color: var(--slate-700);
      }

      &--active {
        color: var(--slate-900);
        font-weight: 600;
        cursor: default;
      }
    }

    &__icon {
      width: 1rem;
      height: 1rem;
      color: currentColor;
    }

    &__separator {
      width: 1rem;
      height: 1rem;
      color: var(--slate-400);
      flex-shrink: 0;
      transform: rotate(90deg);
    }
  }
</style>
